import { EventEmitter } from "events";
import { TokenSecret, ConfigSource } from "../types/types";
import { ConfigNotFoundException } from "../errors/error";

export class ConfigManager extends EventEmitter {
    private config?: TokenSecret;
    private configSource?: ConfigSource;

    constructor() {
        super();
    }

    setConfigSource(source: ConfigSource): void {
        this.configSource = source;
    }

    setConfig(cfg: TokenSecret): void {
        this.config = { ...cfg };
        this.emit("configAvailable", this.config);
    }

    getConfig(): TokenSecret | undefined {
        return this.config;
    }

    async loadConfig(): Promise<TokenSecret> {
        if (!this.configSource) {
            throw new ConfigNotFoundException("Config source not set");
        }
        try {
            const config = await this.configSource();
            this.setConfig(config);
            return config;
        } catch (error) {
            throw new ConfigNotFoundException("Error loading configuration");
        }
    }
}

export const configManager = new ConfigManager();